// extracted by mini-css-extract-plugin
export default {"vendorCardItem":"vendorCard_vendorCardItem__zTPo2","vendorCardInfoType":"vendorCard_vendorCardInfoType__n9w6Z","textOverflow":"vendorCard_textOverflow__xM0Bi"};